export default "__VITE_ASSET__DdrX6sYf__"